import { observer } from 'mobx-react';
import * as React from 'react';

interface Props {}

const Divider: React.FC<Props> = () => (
  <div className="flex place-items-center place-content-center bg-gray-200 w-full h-px"></div>
);

export default observer(Divider);
